module.exports = __webpack_public_path__ + "static/media/sidenav-icon-variations.65a6a99f.svg";